export const projectFinanceQueryKeys = {
  all: ['project-finance'] as const,
  details: () => [...projectFinanceQueryKeys.all, 'detail'] as const,
  detail: (projectId: string) => [...projectFinanceQueryKeys.details(), projectId] as const,
};
